var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeepMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 178,
    viewBox: "0 0 124 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9994 177.454V159.168C72.9994 158.414 72.6968 157.692 72.1584 157.16C71.62 156.627 70.8897 156.328 70.1282 156.328H37.8857C36.9243 156.324 35.973 156.133 35.0861 155.766C34.1993 155.399 33.3943 154.862 32.7171 154.187C32.04 153.512 31.5038 152.712 31.1394 151.832C30.775 150.952 30.5893 150.01 30.5931 149.059V122.424C30.6258 121.804 30.4526 121.192 30.1001 120.679C29.7475 120.166 29.235 119.782 28.6407 119.584L20.8026 117C20.2397 116.814 19.726 116.505 19.2988 116.098C18.8717 115.69 18.5419 115.193 18.3335 114.643C18.1715 114.064 18.139 113.456 18.2381 112.863C18.3373 112.27 18.5657 111.705 18.9077 111.207L30.3921 92.0972C30.3921 91.9268 30.3921 91.9268 30.3921 91.9268C30.4762 91.7537 30.5435 91.573 30.5931 91.3873C30.607 91.1982 30.607 91.0084 30.5931 90.8194C30.6055 90.7633 30.6055 90.7051 30.5931 90.649C30.5274 81.6239 32.7083 72.7216 36.9434 64.7271H135.467C137.807 69.1456 139.538 73.875 140.597 78.7899C142.499 87.6171 142.175 96.7714 139.655 105.446C137.134 114.12 132.494 122.047 126.144 128.529C126.066 128.626 125.999 128.731 125.943 128.841C125.798 129.017 125.673 129.207 125.569 129.409C125.556 129.626 125.556 129.845 125.569 130.062C125.553 130.194 125.553 130.328 125.569 130.46V177.454",
    stroke: "#FF6200",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 116L85 19.9999",
    stroke: "#FF6200",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.057 49L85 49V40.8311C85 36.3672 86.8914 32.0862 90.258 28.9297C93.6246 25.7733 98.1908 24 102.952 24L128 24L128 32.1688C128 36.6312 126.11 40.9109 122.745 44.0671C119.381 47.2233 114.817 48.9977 110.057 49V49Z",
    stroke: "#FF6200",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6116 27L85 27V18.8311C85 14.3672 82.9327 10.0862 79.2529 6.92971C75.5731 3.77326 70.5822 2 65.3781 2L38 2V10.1688C38 14.6312 40.0659 18.9109 43.7435 22.0671C47.4211 25.2233 52.4093 26.9977 57.6116 27Z",
    stroke: "#FF6200",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2725 89.5452H101.454C103.111 89.5452 104.454 90.8883 104.454 92.5452V111.363",
    stroke: "#FF6200",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6359 79.6362H69.4541C67.7972 79.6362 66.4541 80.9794 66.4541 82.6362V101.454",
    stroke: "#FF6200",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepMobile);
export default __webpack_public_path__ + "static/media/deep-mobile.55095504.svg";
export { ForwardRef as ReactComponent };